import script from "./Main.vue?vue&type=script&lang=ts&setup=true"
export * from "./Main.vue?vue&type=script&lang=ts&setup=true"

import "./Main.vue?vue&type=style&index=0&id=8fd8ba02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd8ba02"]])

export default __exports__